import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { Menu } from 'lucide-react'
import { Brand } from '@/components/dashboard/brand'
import { Sidebar } from '@/components/dashboard/sidebar'

import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetTitle,
    SheetTrigger
} from '@/components/ui/sheet'

export const MobileHeader: FC = (): ReactNode => {
    const router = useRouter()
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const close = () => setOpen(false)

        router.events.on('routeChangeStart', close)

        return () => router.events.off('routeChangeStart', close)
    }, [router.events])

    return (
        <header className='sticky top-0 z-30 flex h-14 items-center justify-between border-b border-sidebar-border bg-sidebar px-4 lg:hidden'>
            <Link
                href='/'
                className='rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring'
            >
                <Brand />
            </Link>

            <Sheet open={open} onOpenChange={setOpen}>
                <SheetTrigger
                    render={
                        <button
                            type='button'
                            className='rounded-lg p-2 text-white transition-colors hover:bg-sidebar-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring'
                        />
                    }
                >
                    <Menu aria-hidden='true' className='size-6' />
                    <span className='sr-only'>Open menu</span>
                </SheetTrigger>

                <SheetContent
                    side='left'
                    showCloseButton={false}
                    className='w-72 max-w-[85vw] gap-0 border-sidebar-border bg-sidebar p-0 text-sidebar-foreground'
                >
                    <SheetTitle className='sr-only'>Menu</SheetTitle>
                    <SheetDescription className='sr-only'>Move between the sections of your dashboard.</SheetDescription>

                    <Sidebar onNavigate={() => setOpen(false)} onClose={() => setOpen(false)} />
                </SheetContent>
            </Sheet>
        </header>
    )
}
